<app-loader class="loader" [ngStyle]="{ display: displayStyles }"></app-loader>
<div style="position: fixed; top: 0; z-index: 10; width: 100%">
  <app-navbar></app-navbar>
</div>
<div
  class="tabs tabstruct set-center"
  style="overflow: hidden; padding-top: 12rem"
>
  <!-- <div class="navi"> -->
  <input type="radio" name="tab" id="tab1" checked="checked" />
  <label for="tab1" class="tab1">SPONSORS</label>
  
  <div class="tab-content-wrapper">
    <!-- <div id="tab-content-1" class="tab-content">
            <div class="type-tab">
                <h1>PRESENTED BY</h1>
                <div class="sponcard" data-wow-delay="0.2s">
                    <a href="https://www.axisbank.com/" target="_blank"><div class="ace" style="width: 250px;
                        height: 150px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        background: transparent;">
                        <img class="add" style="max-width: 400px; height: auto; padding: 50px 10px;" src="https://eureka2023.s3.ap-south-1.amazonaws.com/sponsors/AXISBANK.BO_BIG.png" class="img2" alt="YES BANK">
                    </div></a>
                </div>
            </div>
        </div> -->

    <!-- <div class="twoinone">

            <div id="tab-content-1" class="tab-content">
                <div class="type-tab two">
                    <h1>ASSOCIATE TITLE</h1>
                    <div class="card">
                        <a href="https://www.unionbankofindia.co.in/english/home.aspx" target="_blank"><div class="ace">
                            <img class="add" style="padding: 40px;" src="https://eureka2022.s3.ap-south-1.amazonaws.com/sponsors/union.webp" class="img2" alt="UNION BANK">
                        </div></a>
                    </div>
                </div>
            </div>
        </div> -->
        
    <div class="kuch">
       <div class="kuch">
      <!-- <div> -->
        <div id="tab-content-1" class="tab-content">
          <div class="type-tab two">
            <h1 style="text-transform: uppercase">Presented By</h1>
            <div class="sponcard" data-wow-delay="0.2s">
              <a href="https://gii.ae/" target="_blank"
                ><div
                  class="ace"
                  style="
                    width: 250px;
                    height: 150px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background: transparent;
                  "
                >
                  <img
                    class="add"
                    src="https://2k21.s3.ap-south-1.amazonaws.com/GII24Logo.png"
                    id="img2"
                    alt="Gulf Islamic Investments"
                    
                  /></div
              ></a>
   
            </div>
          </div>
        </div>
      </div>
      <div>
     
        <!-- <div class="heads"><h1>SOCIAL MEDIA PARTNERS</h1></div>
                <div class="flexall">
                <div *ngFor="let lis of socpart">
                <div class="card ex">
                    <a href="{{lis.link}}" target="_blank"><div class="ace">
                        <img src="{{lis.img}}" class="img2" alt="">
                    </div></a>
                </div>
            </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <h2 style="color: white;">For sponsorship opportunities : <a style="color: white; font-family: 'Gotham';" href="mailto:marketing@ecell.in" >marketing@ecell.in</a> </h2> -->
</div>
<div class="set-not-center">
  <app-footer></app-footer>
</div>
